module.exports = __webpack_public_path__ + "img/b6-4.7a5f3a8.png";